import { render, staticRenderFns } from "./ListQueenDelete.vue?vue&type=template&id=66c78497&scoped=true&"
import script from "./ListQueenDelete.vue?vue&type=script&lang=js&"
export * from "./ListQueenDelete.vue?vue&type=script&lang=js&"
import style0 from "./ListQueenDelete.vue?vue&type=style&index=0&id=66c78497&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c78497",
  null
  
)

export default component.exports